import script from "./ForestInFocus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForestInFocus.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__